// Импортируем 'React' - основную библиотеку для создания компонентов.
// Этот импорт был обязателен в старых версиях React, но в новых (с JSX-трансформацией)
// его можно не писать в каждом файле компонента. Однако в главном файле index.js 
// он по-прежнему необходим для работы.
import React from 'react';

// Импортируем 'ReactDOM' - это библиотека, которая отвечает за "отрисовку" (рендеринг) 
// React-компонентов в реальном DOM-дереве браузера. Мы используем 'react-dom/client',
// так как это современный API, представленный в React 18, для создания корневого элемента.
import ReactDOM from 'react-dom/client';

// Импортируем глобальные стили. Эти стили будут применяться ко всему приложению.
// Здесь мы определим базовые стили для body, сброс отступов, переменные для цветов и шрифты.
// Webpack (сборщик проектов, используемый в Create React App) поймет эту строчку
// и вставит содержимое main.css в итоговую сборку сайта.
import './assets/css/main.css';

// Импортируем самый главный, родительский компонент нашего приложения.
// Внутри него, как в матрешке, будут находиться все остальные компоненты:
// шапка, секции, подвал и т.д.
// Мы создадим этот файл следующим.
import App from './App';

// Находим в DOM тот самый элемент <div id="root"></div>, который мы создали в public/index.html.
// document.getElementById - это стандартная браузерная функция для поиска элемента по его ID.
const rootElement = document.getElementById('root');

// С помощью ReactDOM.createRoot() мы создаем "корень" нашего React-приложения,
// привязанный к найденному div-элементу. Этот новый API позволяет использовать
// конкурентные возможности React 18 (например, автоматический батчинг обновлений).
const root = ReactDOM.createRoot(rootElement);

// root.render() - это команда, которая говорит React: "Возьми компонент,
// который я передаю тебе в скобках, и отрисуй его со всем содержимым внутри
// элемента, к которому ты привязан".
root.render(
  // <React.StrictMode> - это специальный вспомогательный компонент от React.
  // Он не отображается на странице, но активирует дополнительные проверки и предупреждения
  // в консоли разработчика. Он помогает находить потенциальные проблемы в приложении
  // на ранних этапах разработки. На продакшн-версию сайта он никак не влияет.
  <React.StrictMode>
    {/* 
      <App /> - это экземпляр нашего главного компонента. Именно с него
      начинается построение всего дерева компонентов нашего сайта.
    */}
    <App />
  </React.StrictMode>
);